
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppImageHolder, AppFileUpload, AppButton } from '@/components';
import { useItemEdit } from '@/modules/item/system/model/edit';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';

export default defineComponent({
    name: ROUTE_NAME_ITEM.SYSTEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppImageHolder, AppFileUpload, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useItemEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
